export type ThemePreference = "light" | "dark" | "system";

export const THEME_STORAGE_KEY = "theme";
export const THEME_COOKIE_NAME = "theme";
export const THEME_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export function isThemePreference(value: string | null | undefined): value is ThemePreference {
  return value === "light" || value === "dark" || value === "system";
}

/** Resolved paint class — dark-only until light theme is product-ready. */
export function resolveThemeForDocument(
  _preference: ThemePreference | null | undefined,
): "light" | "dark" {
  return "dark";
}

export function themePreferenceCookieValue(preference: ThemePreference): string {
  return `${THEME_COOKIE_NAME}=${preference}; Path=/; Max-Age=${THEME_COOKIE_MAX_AGE}; SameSite=Lax`;
}
